import React, { useState, useEffect } from "react";
import { Input, Button, Modal, ModalBody, Badge } from "reactstrap";
import { useNavigate, useSearchParams } from "react-router-dom";
import { io } from "socket.io-client";
import ReservationOffcanvas from "./Reservation";
import api from "../../../utils/api";
import ActiveOrderSlider from "./ActiveOrderSlider";
import PaymentBar from "./PaymentBar";

const GuestMenu = () => {
  const navigate = useNavigate();

  /* ---------------- STATES ---------------- */

  const [categories, setCategories] = useState([]);
  const [items, setItems] = useState([]);
  const [ratingsMap, setRatingsMap] = useState({});
  const [offer, setOffers] = useState("");
  const [BillTotal, setBillTotal] = useState({});
  const [orderStatus, setOrderStatus] = useState("");
  const [propertyModules, setPropertyModules] = useState([]);
  const [activeCategory, setActiveCategory] = useState("all");
  const [selectedItem, setSelectedItem] = useState(null);
  const [cart, setCart] = useState([]);
  const [socket, setSocket] = useState(null);
  const [serviceType, setServiceType] = useState("restaurant");
  const [vegMode, setVegMode] = useState(true);
  const [searchText, setSearchText] = useState("");
  const [priceType, setPriceType] = useState("full");
  const [quantity, setQuantity] = useState(1);
  const [propertyName, setPropertyName] = useState("");
  const [showReservation, setShowReservation] = useState(false);
  const tableNo = localStorage.getItem("tableNo") || "";
  const [orderSummary, setOrderSummary] = useState(null);

  const [params] = useSearchParams();

const tenant = params.get("tenant");
  const tableNumber = params.get("table");
  console.log("TENANT =", tenant);
  console.log("TABLE =", tableNumber);

useEffect(() => {
  if (!tenant) return;

  console.log("🔥 NEW TENANT =", tenant);

  setPropertyModules([]);
  setItems([]);
  setCategories([]);
  setCart([]);
  setOrderSummary(null);
  setServiceType("restaurant");

  if (tableNumber) {
    localStorage.setItem("tableNo", tableNumber); // ✅ only table allowed
  }

}, [tenant]);

  useEffect(() => {
    if (!tenant) return;

    const loadProperty = async () => {
      try {
        const { data } = await api.get(`/guest/property-info`, {
          params: { tenant }
        });
        if (data?.propertyName) {
          setPropertyName(data.propertyName);
        }

        if (Array.isArray(data?.modules)) {
          setPropertyModules(data.modules);
        }

      } catch (err) {
        console.error("Failed to load property", err);
      }
    };

    loadProperty();
  }, [tenant]);

  useEffect(() => {
    if (!tenant) return;

    api.get(`/guest/offers`, {
      params: { tenant, type: serviceType }
    })
      .then(({ data }) => {
        if (Array.isArray(data)) {
          setOffers(data);
        }
      });
  }, [tenant, serviceType]);

useEffect(() => {
  console.log("MODULES LOADED =", propertyModules);
}, [propertyModules]);
  /* ---------------- FETCH DATA ---------------- */

  useEffect(() => {
    if (!tenant) return;

    api.get(`/guest/menu-items`, {
      params: { tenant }
    })
      .then(({ data }) => {
        if (!Array.isArray(data)) return;

        setItems(
          data.map(i => ({
            id: i._id,
            name: i.name,
            desc: i.description,
            image: i.imageUrl,
            categoryId: i.category?._id,
            categoryName: i.category?.name,
            menuGroup: i.menuGroup,
            type: i.type,
            fullPrice: i.priceFull || 0,
            halfPrice: i.priceHalf || 0,
            sizes: i.sizes || [],
            prepTime: i.preparationTime || 0   // ✅ NEW
          }))
        );


      });
  }, [tenant]);


  useEffect(() => {
    const saved = localStorage.getItem("currentOrder");
    if (!saved) return

    const parsed = JSON.parse(saved);
    const normalized = {
      ...parsed,
      orderId: parsed.orderId || parsed._id // ✅ FIX
    };
    setOrderSummary(normalized);
    setOrderStatus(normalized.status);
    setBillTotal(normalized.total);

  }, []);


  useEffect(() => {
    if (!tenant) return;

    const s = io("https://guest.nexifytechnology.in", {
      transports: ["websocket"],
    });

    s.on("connect", () => {
      console.log("🟢 Guest connected:", s.id);

      // 🔥 JOIN TENANT ROOM
      s.emit("join-tenant", tenant);
    });

    s.on("order-updated", (updatedOrder) => {
      console.log("📦 order-updated received:", updatedOrder);

      const saved = localStorage.getItem("currentOrder");
      if (!saved) return;

      const current = JSON.parse(saved);

      if (
        String(updatedOrder._id) ===
        String(current.orderId || current._id)
      ) {

        const updated = {
          ...current,
          orderId: updatedOrder._id, // ✅ FIX
          status: updatedOrder.status,
          items: updatedOrder.items || [],
          total: updatedOrder.total,
          finalAmount: updatedOrder.finalAmount,
          discount: updatedOrder.discount,
          paymentStatus: updatedOrder.paymentStatus,
          paymentType: updatedOrder.paymentType
        };

        console.log("✅ Updating guest UI");

        setOrderSummary(updated);
        setOrderStatus(updatedOrder.status);

        localStorage.setItem("currentOrder", JSON.stringify(updated));
      }
    });

    setSocket(s);

    return () => s.disconnect();
  }, [tenant]);


  // 🔥 LOAD CART ON PAGE REFRESH
  useEffect(() => {
    const savedCart = localStorage.getItem("guestCart");
    if (savedCart) {
      const parsed = JSON.parse(savedCart);
      console.log("🔄 CART LOADED FROM STORAGE =", parsed);
      setCart(parsed);
    }
  }, []);


  const fetchOrder = async () => {
    try {

   const { data } = await api.get(
  `/guest/orders/${orderSummary.orderId || orderSummary._id}`,
  {
    params: { tenant } // ✅ use URL tenant
  }
);
      console.log("🔄 ORDER REFRESH:", data);

      const normalized = {
        ...data,
        orderId: data._id // ✅ FIX
      };

      setOrderSummary(normalized);
      setOrderStatus(data.status);

      localStorage.setItem("currentOrder", JSON.stringify(normalized));
    } catch (err) {
      console.error("❌ Order refresh failed", err);
    }
  };


  /* ---------------- Table Number ---------------- */

  const loadRatings = async () => {
    const currentTenant = tenant;

    console.log("🟢 loadRatings() called");
    console.log("🟢 tenant used for ratings =", currentTenant);

    if (!currentTenant) {
      console.log("🔴 No tenant — skipping ratings fetch");
      return;
    }

    try {
      const { data } = await api.get(`/guest-review`, {
        params: { tenant: currentTenant }
      });

      console.log("⭐ RATINGS RAW RESPONSE:", data);

      if (!Array.isArray(data)) {
        console.log("🔴 Ratings response is not array — aborting");
        return;
      }

      const map = {};

      data.forEach(r => {
        map[r.itemId] = {
          avgRating: r.avgRating,
          totalReviews: r.totalReviews
        };
      });

      console.log("⭐ FINAL RATINGS MAP:", map);

      setRatingsMap(map);

    } catch (err) {
      console.error("Ratings load failed", err);
    }
  };

  useEffect(() => {
    if (tenant) {
      loadRatings();
    }
  }, [tenant]);


  useEffect(() => {
    const saved = localStorage.getItem("currentOrder");
    if (!saved) return;

    const parsed = JSON.parse(saved);

    if (parsed.orderPlaced) {
      setOrderSummary(parsed);
      setBillTotal(parsed.total);
    }
  }, []);

  useEffect(() => {
    setActiveCategory("all");
  }, [serviceType]);


  useEffect(() => {
    const loadCategories = async () => {
      try {
        const endpoint =
          serviceType === "restaurant"
            ? "/guest/restaurant-categories"
            : "/guest/bar-categories";

        const { data } = await api.get(endpoint, {
          params: { tenant }
        });

        const mapped = data.map(c => ({
          id: c._id,
          name: c.name
        }));

        setCategories([
          { id: "all", name: "All" },
          ...mapped
        ]);

      } catch (err) {
        console.error("Category load failed", err);
      }
    };

    loadCategories();
  }, [serviceType, tenant]);


  useEffect(() => {
    const handleFocus = () => {
      loadRatings();
    };

    window.addEventListener("focus", handleFocus);

    return () => window.removeEventListener("focus", handleFocus);
  }, []);

useEffect(() => {
  if (!propertyModules.length) return;

  if (propertyModules.length === 1) {
    setServiceType(propertyModules[0]);
  } else if (!propertyModules.includes(serviceType)) {
    setServiceType(propertyModules[0]);
  }
}, [propertyModules]);

  /* ---------------- FILTER LOGIC ---------------- */

  const filteredItems = items.filter(i => {
    const serviceMatch = i.menuGroup === serviceType;

    const categoryMatch =
      activeCategory === "all" || i.categoryId === activeCategory;

    const vegMatch =
      serviceType === "bar"
        ? true // ❌ no veg/non-veg filter for bar
        : vegMode
          ? i.type === "Veg"
          : i.type === "Non-Veg";

    const searchMatch = i.name
      .toLowerCase()
      .includes(searchText.toLowerCase());

    return serviceMatch && categoryMatch && vegMatch && searchMatch;
  });


  /* ---------------- GROUP BY CATEGORY ---------------- */

  const groupedItems = Object.values(
    filteredItems.reduce((acc, item) => {
      if (!acc[item.categoryName]) {
        acc[item.categoryName] = {
          name: item.categoryName,
          items: []
        };
      }
      acc[item.categoryName].items.push(item);
      return acc;
    }, {})
  );

  /* ---------------- PRICE ---------------- */

  const unitPrice =
    serviceType === "restaurant"
      ? priceType === "half"
        ? selectedItem?.halfPrice
        : selectedItem?.fullPrice
      : selectedItem?.sizes.find(s => s.size === priceType)?.price || 0;


  const totalPrice = unitPrice * quantity;

  const RatingBadge = ({ rating, count }) => {
    if (!rating || rating <= 0) return null;

    return (
      <div
        style={{
          background: "#28a745",
          color: "#fff",
          padding: "3px 8px",
          borderRadius: 12,
          fontSize: 12,
          fontWeight: 700,
          display: "flex",
          alignItems: "center",
          gap: 4
        }}
      >
        {rating}
        <i className="ri-star-fill" style={{ fontSize: 12 }} />
        {count > 0 && (
          <span style={{ fontSize: 10, opacity: 0.8 }}>
            ({count})
          </span>
        )}
      </div>
    );
  };

  const hasRestaurant = propertyModules.includes("restaurant");
const hasBar = propertyModules.includes("bar");
const showToggle = hasRestaurant && hasBar;
  /* ---------------- UI ---------------- */
  return (
    <div
      style={{
        height: "100vh",
        display: "flex",
        flexDirection: "column",
        background: "#f6f8fa"
      }}
    >
      {/* ================= NAVBAR CARD ================= */}
      <div
        style={{
          position: "sticky",
          top: 0,
          zIndex: 1000,
          padding: 12,
          background: "#f6f8fa"
        }}
      >
        <div
          style={{
            background: "#ffffff",
            borderRadius: 20,
            padding: 16,
            boxShadow: "0 6px 18px rgba(0,0,0,0.02)"
          }}
        >
          {/* TOP ROW */}
          <div className="d-flex justify-content-between align-items-center">
            <div>
              <div style={{ fontSize: 12, color: "#888" }}>
                Your Location
              </div>
              <div style={{ fontSize: 22, fontWeight: 800 }}>
                {propertyName}
              </div>
            </div>

            <div className="d-flex align-items-center gap-2">
              <Button
                size="sm"
                color="primary"
                className="rounded-pill px-3 fw-bold"
                onClick={() => setShowReservation(true)}
              >
                + Reservation
              </Button>

              <div
                onClick={() =>
                  navigate(`/apps-cart?tenant=${tenant}&table=${tableNo}`)}>
                <lord-icon
                  src="https://cdn.lordicon.com/uisoczqi.json"
                  trigger="loop"
                  delay="2000"
                  colors="primary:#687cfe,secondary:#46e8ad"
                  style={{ width: "26px", height: "26px" }}>
                </lord-icon>

                {cart.length > 0 && (
                  <span
                    style={{
                      position: "absolute",
                      top: 28,
                      right: 24,
                      background: "red",
                      color: "#fff",
                      fontSize: 10,
                      borderRadius: "50%",
                      padding: "3px 8px"
                    }}
                  >
                    {cart.length}
                  </span>
                )}
              </div>
            </div>
          </div>
          {/* SEARCH + TOGGLE */}
          <div className="mt-3 d-flex align-items-center gap-3">
            <div style={{ flex: 1, position: "relative" }}>
              <i
                className="ri-search-line"
                style={{
                  position: "absolute",
                  left: 14,
                  top: "50%",
                  transform: "translateY(-50%)",
                  color: "#999"
                }}
              />
              <Input
                placeholder="Search food..."
                value={searchText}
                onChange={(e) => setSearchText(e.target.value)}
                style={{
                  paddingLeft: 40,
                  borderRadius: 30,
                  border: "1px solid #eee",
                  background: "#f9fafb"
                }}
              />
            </div>

            {/* Veg Toggle */}
            {serviceType === "restaurant" && (
              <div className="text-center">
                <div
                  style={{
                    fontSize: 11,
                    fontWeight: 700,
                    color: vegMode ? "#28a745" : "#8b0000"
                  }}
                >
                  {vegMode ? "VEG" : "NON-VEG"}
                </div>

                <div
                  onClick={() => setVegMode(!vegMode)}
                  style={{
                    width: 46,
                    height: 24,
                    background: vegMode ? "#28a745" : "#8b0000",
                    borderRadius: 20,
                    position: "relative",
                    cursor: "pointer"
                  }}
                >
                  <div
                    style={{
                      width: 20,
                      height: 20,
                      background: "#fff",
                      borderRadius: "50%",
                      position: "absolute",
                      top: 2,
                      left: vegMode ? 24 : 2,
                      transition: "0.3s"
                    }}
                  />
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
      {/* ================= ORDER TRACKER PROMPT ================= */}
      <div className="d-flex justify-content-center mb-3 ">
       {orderSummary?.items?.length > 0 && (
  <ActiveOrderSlider
    order={orderSummary}
    tenant={tenant}
    table={tableNo}
    menuItems={items}
    refreshOrder={fetchOrder}
  />
)}

</div>
      {/* ================= SCROLLABLE CONTENT ================= */}
      <div
        style={{
          flex: 1,
          overflowY: "auto",
          paddingBottom: 140
        }}
      >
{showToggle && (
  <div className="d-flex justify-content-center mt-3 mb-3 ">
    <div
      style={{
        display: "flex",
        background: "#fff",
        borderRadius: 30,
        padding: 4,
        width: 300,
        boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
      }}
    >
      <div
        onClick={() => setServiceType("restaurant")}
        style={{
          flex: 1,
          textAlign: "center",
          padding: "8px 0",
          borderRadius: 24,
          cursor: "pointer",
          fontWeight: 700,
          background: serviceType === "restaurant" ? "#e9f7ef" : "#fff",
          color: serviceType === "restaurant" ? "#28a745" : "#555",
        }}
      >
        Restaurant
      </div>

      <div
        onClick={() => setServiceType("bar")}
        style={{
          flex: 1,
          textAlign: "center",
          padding: "8px 0",
          borderRadius: 24,
          cursor: "pointer",
          fontWeight: 700,
          background: serviceType === "bar" ? "#e9f7ef" : "#fff",
          color: serviceType === "bar" ? "#28a745" : "#555",
        }}
      >
        Bar
      </div>
    </div>
  </div>
)}
        <div>
          {/* CATEGORY SLIDER */}
          <div
            className="d-flex px-3 py-2 gap-3"
            style={{
              overflowX: "auto",
              whiteSpace: "nowrap"
            }}
          >
            {categories.map(c => (
              <div
                key={c.id}
                onClick={() => setActiveCategory(c.id)}
                style={{
                  padding: "6px 14px",
                  borderRadius: 20,
                  fontSize: 13,
                  fontWeight: 600,
                  cursor: "pointer",
                  background:
                    activeCategory === c.id ? "#28a745" : "#f1f1f1",
                  color:
                    activeCategory === c.id ? "#fff" : "#444",
                  flex: "0 0 auto"
                }}
              >
                {c.name}
              </div>
            ))}
          </div>
          {/* ITEMS GROUPED */}
          <div className="px-3">
            {groupedItems.map(group => (
              <div key={group.id}>
                <h6 style={{ marginTop: 20, fontWeight: 700 }}>
                  {group.name}
                </h6>

                {group.items.map(item => (
                  <div
                    key={item.id}
                    className="d-flex gap-3 mb-3"
                    onClick={() => {
                      setSelectedItem(item);
                      setQuantity(1);
                      setPriceType("full");
                    }}
                  >
                    <img
                      src={item.image}
                      alt=""
                      style={{ width: 90, height: 90, borderRadius: 14 }}
                    />
                    <div style={{ flex: 1, position: "relative" }}>
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center"
                        }}
                      >
                        <strong>{item.name}</strong>

                        <RatingBadge
                          rating={ratingsMap[String(item.id)]?.avgRating}
                          count={ratingsMap[String(item.id)]?.totalReviews}
                        />
                      </div>

                      <p className="small text-muted mb-1">{item.desc}</p>
                      <strong>₹{item.fullPrice}</strong>
                    </div>

                  </div>
                ))}
              </div>
            ))}
          </div>
        </div>
      </div>
      {/* MODAL */}
      <Modal isOpen={!!selectedItem} toggle={() => setSelectedItem(null)} centered>
        {selectedItem && (
          <ModalBody>
            <img
              src={selectedItem.image}
              alt=""
              className="img-fluid rounded mb-3"
            />

            <h5>{selectedItem.name}</h5>
            <p className="text-muted small">{selectedItem.desc}</p>

            <div className="d-flex gap-2 my-3 flex-wrap">

              {/* 🍽 RESTAURANT */}
              {serviceType === "restaurant" && (
                <>
                  {selectedItem.halfPrice > 0 && (
                    <Button
                      outline
                      active={priceType === "half"}
                      onClick={() => {
                        console.log("🥗 PlateType selected = HALF");
                        setPriceType("half");
                      }}
                    >
                      Half • ₹{selectedItem.halfPrice}
                    </Button>
                  )}
                  <Button
                    outline
                    active={priceType === "full"}
                    onClick={() => {
                      console.log("🍽 PlateType selected = FULL");
                      setPriceType("full");
                    }}
                  >
                    Full • ₹{selectedItem.fullPrice}
                  </Button>
                </>
              )}
              {/* 🍺 BAR */}
              {serviceType === "bar" &&
                selectedItem.sizes.map(s => (
                  <Button
                    key={s._id}
                    outline
                    active={priceType === s.size}
                    onClick={() => setPriceType(s.size)}
                  >
                    {s.size} • ₹{s.price}
                  </Button>
                ))
              }
            </div>
            <div className="d-flex align-items-center gap-3 my-3">
              <strong>Quantity</strong>
              <Button size="sm" onClick={() => quantity > 1 && setQuantity(quantity - 1)}>−</Button>
              <span>{quantity}</span>
              <Button size="sm" onClick={() => setQuantity(quantity + 1)}>+</Button>
            </div>

            <Button
              color="success"
              block
              onClick={() => {
                console.log("🧪 BEFORE ADD — priceType =", priceType);
                console.log("🧪 serviceType =", serviceType);
                const itemToCart = {
                  menuItemId: selectedItem.id,
                  name: selectedItem.name,
                  qty: quantity,
                  price: unitPrice,
                  image: selectedItem.image,
                  serviceType,
                  addons: [],

                  ...(serviceType === "restaurant"
                    ? { plateType: priceType === "half" ? "Half" : "Full" }
                    : { size: priceType })
                };
                console.log("🛒 ADDING TO CART =", itemToCart);
                const updatedCart = [...cart, itemToCart];
                console.log("🛒 UPDATED CART =", updatedCart);

                setCart(updatedCart);
                localStorage.setItem("guestCart", JSON.stringify(updatedCart));
                setSelectedItem(null);
              }}
            >
              Add to Cart • ₹{totalPrice}
            </Button>
          </ModalBody>
        )}
      </Modal>
      <PaymentBar
        order={orderSummary}
        tenant={tenant}
        table={tableNo}
      />
      <ReservationOffcanvas
        isOpen={showReservation}
        toggle={() => setShowReservation(false)}
        tenant={tenant}
        items={items}
      />
    </div>

  );
};

export default GuestMenu;
